import * as _ from 'lodash';


export const getPriceSheets = (priceSheets: any): any => {
  return _.chain(priceSheets)
  .map((priceSheet: any, index: number) => {
    return Object.assign({}, {
      title: priceSheet.price_sheet_name,
      id: priceSheet.price_sheet_number,
      active: false,
      icon: priceSheet.default ? `number-round-icon num-${priceSheet.default}` : '',
    }, priceSheet);
  }).sortBy('default').value();
};
